/* ============================================================================
   Calendrier Maison pour Tous — assets/mpt-calendrier.js
   ----------------------------------------------------------------------------
   Lit le JSON depose par la section Liquid dans <script id="mpt-cal-data">
   (genere a partir des produits Shopify) et construit deux vues :
     - "Agenda" : liste chronologique groupee par mois (vue par defaut)
     - "Mois"   : grille FullCalendar 6 (construite a la demande)
   Plus : filtres par categorie, regroupement des series (cours hebdomadaires),
   carte de survol, repli des evenements passes.

   Aucun flux externe : la source de verite, ce sont les produits de la boutique.
   ========================================================================== */
(function () {
  'use strict';

  var socle  = document.getElementById('mpt-cal');
  var source = document.getElementById('mpt-cal-data');
  if (!socle || !source) return;

  /* ---------------------------------------------------------------- outils */

  var MOIS_COURT = ['janv.', 'f\u00E9vr.', 'mars', 'avr.', 'mai', 'juin',
                    'juil.', 'ao\u00FBt', 'sept.', 'oct.', 'nov.', 'd\u00E9c.'];
  var MOIS_LONG  = ['janvier', 'f\u00E9vrier', 'mars', 'avril', 'mai', 'juin',
                    'juillet', 'ao\u00FBt', 'septembre', 'octobre', 'novembre', 'd\u00E9cembre'];
  var JOURS      = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  /* Couleur par mot-cle present dans la categorie. Palette MPT 2026. */
  var COULEURS = [
    ['retraite',    '#604876'],  // violet logo
    ['immersion',   '#604876'],
    ['pelerinage',  '#8B2FC9'],  // violet vif
    ['festival',    '#F98B3E'],  // orange vif
    ['satsang',     '#8B2FC9'],
    ['darshan',     '#BCA05A'],  // dore logo
    ['ligne',       '#4DBD95'],  // bleu-vert
    ['cours',       '#4DBD95'],
    ['formation',   '#4DBD95'],
    ['atelier',     '#1A5218'],  // vert foret
    ['art',         '#D93569'],  // rose
    ['musique',     '#D93569'],
    ['yoga',        '#1A5218'],
    ['meditation',  '#1A5218'],
    ['rituel',      '#BCA05A'],
    ['celebration', '#E2231A'],  // vermillon
    ['enseignement','#604876']
  ];
  var COULEUR_DEFAUT = '#604876';

  function sansAccent(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function couleur(type) {
    var t = sansAccent(type);
    for (var i = 0; i < COULEURS.length; i++) {
      if (t.indexOf(COULEURS[i][0]) !== -1) return COULEURS[i][1];
    }
    return COULEUR_DEFAUT;
  }

  function echappe(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------- nettoyage des libelles */
  /* Les titres produits MPT finissent par la date :
     "Atmakriya & Navaratri — Yoga et Meditation - 13 au 15 novembre 2026".
     On retire la date (deja affichee dans la pastille) puis on coupe sur
     " — " pour separer titre et sous-titre.                                 */

  var MOIS_RE = '(?:janvier|f[e\u00E9]vrier|mars|avril|mai|juin|juillet|ao[u\u00FB]t|'
              + 'septembre|octobre|novembre|d[e\u00E9]cembre)';
  var DATE_RE = '\\d{1,2}\\s*(?:er)?\\s*(?:' + MOIS_RE + ')?\\s*(?:20\\d{2})?';

  var MOTIFS = [
    // "du 16 septembre 2026 au 21 avril 2027", "13 au 15 novembre 2026", "20, 21 juin 2026"
    new RegExp('(?:du\\s+|le\\s+|des\\s+)?' + DATE_RE + '\\s*(?:au|et|[-\u2013\u2014,])\\s*' + DATE_RE + '\\s*$', 'i'),
    // "29 mars 2026"
    new RegExp('(?:du\\s+|le\\s+)?\\d{1,2}\\s*(?:er)?\\s*' + MOIS_RE + '\\s*(?:20\\d{2})?\\s*$', 'i'),
    // amorces orphelines laissees par les motifs precedents
    /(?:d[e\u00E9]marrage|d[e\u00E8]s|\u00E0\s+partir\s+du?|le)\s*$/i,
    // ponctuation de fin
    /[\s,;:.\u2013\u2014\u2022|/-]+$/
  ];

  function nettoieTitre(titre) {
    var t = (titre || '').trim();
    for (var passe = 0; passe < 4; passe++) {
      var avant = t;
      MOTIFS.forEach(function (re) { t = t.replace(re, ''); });
      if (t === avant) break;
    }
    return t.trim() || (titre || '').trim();
  }

  function decoupeTitre(titre) {
    var bouts = nettoieTitre(titre).split(/\s+[\u2013\u2014]\s+/);
    return { titre: bouts.shift(), sous: bouts.join(' \u00B7 ') };
  }

  /* ------------------------------------------------------- dates et heures */
  /* Deux formats arrivent du Liquid, et les deux doivent afficher l'heure de
     Paris :
       "2026-10-24T08:00:00"   sans fuseau  -> deja de l'heure de Paris (le
                                               filtre `date` de Liquid rend les
                                               metachamps dans le fuseau de la
                                               boutique). On l'affiche telle quelle.
       "2026-09-16T18:30:00Z"  avec Z       -> vrai instant UTC, on le convertit
                                               en Europe/Paris via Intl.
     Dans les deux cas l'heure affichee est celle de Paris, quel que soit le
     fuseau du visiteur : c'est ce qu'on veut pour un calendrier d'evenements. */

  var FORMAT_PARIS = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
  });
  var JOUR_PARIS = new Intl.DateTimeFormat('en', { timeZone: 'Europe/Paris', weekday: 'short' });
  var AVEC_FUSEAU = /([Zz]|[+-]\d{2}:?\d{2})$/;

  function jourSemaineDe(a, m, j) {
    return new Date(Date.UTC(a, m - 1, j, 12)).getUTCDay();
  }

  function parties(iso, journee) {
    var brut = String(iso);

    // Journee entiere, ou date sans fuseau : on lit les composants tels quels.
    if (journee || !AVEC_FUSEAU.test(brut)) {
      var n = brut.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
      if (!n) return null;
      var aHeure = !journee && n[4] !== undefined;
      return {
        a: +n[1], m: +n[2], j: +n[3],
        h:   aHeure ? +n[4] : null,
        min: aHeure ? +n[5] : null,
        jourSemaine: jourSemaineDe(+n[1], +n[2], +n[3])
      };
    }

    var dt = new Date(brut);
    if (isNaN(dt)) return null;
    var p = {};
    FORMAT_PARIS.formatToParts(dt).forEach(function (x) { p[x.type] = x.value; });
    var court = JOUR_PARIS.format(dt);
    return {
      a: +p.year, m: +p.month, j: +p.day, h: +p.hour, min: +p.minute,
      jourSemaine: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(court)
    };
  }

  /* Instant utilise pour trancher passe / a venir. Construit a partir des
     composants deja normalises, donc valable pour les deux formats. */
  function instantFin(d, f) {
    var b = f || d;
    return new Date(b.a, b.m - 1, b.j, b.h === null ? 23 : b.h, b.min === null ? 59 : b.min);
  }

  function heure(p) {
    if (p.h === null) return '';
    return p.min ? p.h + 'h' + String(p.min).padStart(2, '0') : p.h + 'h';
  }

  function memeJour(a, b) { return b && a.a === b.a && a.m === b.m && a.j === b.j; }

  function cle(p) {
    return p.a + '-' + String(p.m).padStart(2, '0') + '-' + String(p.j).padStart(2, '0');
  }

  /* -------------------------------------------------- lecture de la source */

  var brut;
  try { brut = JSON.parse(source.textContent || '[]'); } catch (e) { brut = []; }

  var maintenant = new Date();
  var evenements = [];

  brut.forEach(function (e) {
    if (!e || !e.debut) return;
    var journee = !!e.journee;
    var d = parties(e.debut, journee);
    if (!d) return;
    var f = e.fin ? parties(e.fin, journee) : null;
    // fin incoherente (anterieure au debut) : on l'ignore
    if (f && (f.a < d.a || (f.a === d.a && (f.m < d.m || (f.m === d.m && f.j < d.j))))) f = null;
    var nom = decoupeTitre(e.titre);
    var nomGroupe = e.titre_groupe ? decoupeTitre(e.titre_groupe) : null;
    evenements.push({
      titre:   nom.titre,
      sous:    nom.sous,
      brut:    e.titre,
      url:     e.url,
      // seances d'un meme produit : de quoi construire la fiche « serie »
      groupe:        e.groupe || '',
      titreGroupe:   nomGroupe ? nomGroupe.titre : '',
      sousGroupe:    nomGroupe ? nomGroupe.sous : '',
      extraitGroupe: e.extrait_groupe || '',
      type:    (e.type || '').trim(),
      image:   e.image || '',
      extrait: e.extrait || '',
      lieu:    e.lieu || '',
      c:       couleur(e.type),
      journee: journee,
      d: d,
      f: f,
      plage: !!f && !memeJour(d, f),
      fin: instantFin(d, f)
    });
  });

  evenements.sort(function (a, b) { return cle(a.d) < cle(b.d) ? -1 : (cle(a.d) > cle(b.d) ? 1 : 0); });
  evenements.forEach(function (e, i) { e.i = i; });

  var aVenir = evenements.filter(function (e) { return e.fin >= maintenant; });
  var passes = evenements.filter(function (e) { return e.fin <  maintenant; }).reverse();

  /* ------------------------------------------- regroupement des « series » */
  /* 3 seances ou plus partageant titre + categorie => une seule fiche, avec
     le rythme detecte et la date de derniere seance.                        */

  function rythme(serie) {
    if (serie.length < 3) return '';
    var jours = serie.map(function (e) { return Date.UTC(e.d.a, e.d.m - 1, e.d.j); });
    var ecarts = [];
    for (var i = 1; i < jours.length; i++) ecarts.push(Math.round((jours[i] - jours[i - 1]) / 864e5));
    function tous(test) { return ecarts.every(test); }
    if (tous(function (x) { return x === 7; }))  return 'chaque ' + JOURS[serie[0].d.jourSemaine];
    if (tous(function (x) { return x === 14; })) return 'un ' + JOURS[serie[0].d.jourSemaine] + ' sur deux';
    if (tous(function (x) { return x >= 27 && x <= 31; })) return 'une fois par mois';
    return '';
  }

  function regroupeSeries(liste, aVenirFlag) {
    var paquets = {}, ordre = [];
    liste.forEach(function (e) {
      // Seances d'un meme produit : on groupe sur le produit (les titres
      // different d'une seance a l'autre). Sinon, sur categorie + titre,
      // ce qui couvre le cas « un produit par date ».
      var k = e.groupe ? 'g:' + e.groupe : e.type + '\0' + e.titre + '\0' + e.sous;
      if (!paquets[k]) { paquets[k] = []; ordre.push(k); }
      paquets[k].push(e);
    });
    var sortie = [];
    ordre.forEach(function (k) {
      var serie = paquets[k];
      if (serie.length < 3) { sortie = sortie.concat(serie); return; }
      var tete = {};
      Object.keys(serie[0]).forEach(function (p) { tete[p] = serie[0][p]; });
      if (tete.titreGroupe) {                 // la fiche porte le nom du produit
        tete.titre = tete.titreGroupe;
        tete.sous = tete.sousGroupe;
        tete.extrait = tete.extraitGroupe || tete.extrait;
      }
      tete.serie = serie;
      tete.rythme = rythme(serie);
      tete.prochaine = !!aVenirFlag;
      sortie.push(tete);
    });
    sortie.sort(function (a, b) { return cle(a.d) < cle(b.d) ? -1 : (cle(a.d) > cle(b.d) ? 1 : 0); });
    return sortie;
  }

  /* ---------------------------------------------------------------- rendus */

  var ICONES = {
    horloge:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    calendrier: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>',
    repete:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/></svg>',
    lieu:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>'
  };

  function texteSerie(e) {
    var dernier = e.serie[e.serie.length - 1];
    var jusqu = 'jusqu\u2019au ' + dernier.d.j + ' ' + MOIS_LONG[dernier.d.m - 1] + ' ' + dernier.d.a;
    return (e.rythme ? e.rythme + ', ' : '') + jusqu + ' \u00B7 ' + e.serie.length + ' s\u00E9ances';
  }

  function texteQuand(e) {
    if (!e.plage) {
      var t = JOURS[e.d.jourSemaine] + ' ' + e.d.j + ' ' + MOIS_LONG[e.d.m - 1] + ' ' + e.d.a;
      if (e.d.h !== null) {
        t += ' \u00B7 ' + heure(e.d) + (e.f && !e.journee ? ' \u2192 ' + heure(e.f) : '');
      }
      return t;
    }
    var memeMois = e.d.m === e.f.m && e.d.a === e.f.a;
    var deb = e.d.j + (memeMois ? '' : ' ' + MOIS_LONG[e.d.m - 1]);
    var t2 = 'du ' + deb + ' au ' + e.f.j + ' ' + MOIS_LONG[e.f.m - 1] + ' ' + e.f.a;
    if (e.d.h !== null) {
      t2 += ' \u00B7 ' + heure(e.d) + (e.f.h !== null ? ' \u2192 ' + heure(e.f) : '');
    }
    return t2;
  }

  function blocDate(e) {
    if (!e.plage) {
      return '<span class="mpt-ev__jour">' + e.d.j + '</span>'
           + '<span class="mpt-ev__moisjour">' + MOIS_COURT[e.d.m - 1] + '</span>'
           + '<span class="mpt-ev__semaine">' + JOURS[e.d.jourSemaine] + '</span>';
    }
    // Plage de dates : les deux jours sont empiles, le mois en dessous.
    var memeMois = e.d.m === e.f.m && e.d.a === e.f.a;
    return '<span class="mpt-ev__jour mpt-ev__jour--plage">' + e.d.j
         +   '<span class="mpt-ev__fleche" aria-hidden="true">\u2192</span></span>'
         + '<span class="mpt-ev__lu"> au </span>'
         + '<span class="mpt-ev__jour mpt-ev__jour--plage">' + e.f.j + '</span>'
         + '<span class="mpt-ev__moisjour">'
         + (memeMois ? MOIS_COURT[e.d.m - 1] : MOIS_COURT[e.d.m - 1] + ' \u2013 ' + MOIS_COURT[e.f.m - 1])
         + '</span>';
  }

  function fiche(e) {
    var a = document.createElement('a');
    a.className = 'mpt-ev';
    a.href = e.url;
    a.style.setProperty('--c', e.c);
    var affiche = e.image
      ? '<div class="mpt-ev__affiche"><img src="' + e.image + '" alt="Affiche : ' + echappe(e.brut) + '" loading="lazy" width="300" height="400"></div>'
      : '<div class="mpt-ev__affiche mpt-ev__affiche--vide">\u0965</div>';
    a.innerHTML =
        '<div class="mpt-ev__date">' + blocDate(e) + '</div>'
      + affiche
      + '<div class="mpt-ev__corps">'
      +   (e.type ? '<span class="mpt-ev__type">' + echappe(e.type) + '</span>' : '')
      +   '<h3 class="mpt-ev__titre" data-ev="' + e.i + '">' + echappe(e.titre) + '</h3>'
      +   (e.sous ? '<p class="mpt-ev__sous">' + echappe(e.sous) + '</p>' : '')
      +   '<p class="mpt-ev__infos">'
      +     '<span>' + (e.plage ? ICONES.calendrier : ICONES.horloge)
      +       echappe((e.prochaine ? 'Prochaine s\u00E9ance : ' : '') + texteQuand(e)) + '</span>'
      +     (e.serie ? '<span>' + ICONES.repete + echappe(texteSerie(e)) + '</span>' : '')
      +     (e.lieu  ? '<span>' + ICONES.lieu   + echappe(e.lieu) + '</span>' : '')
      +   '</p>'
      +   (e.extrait ? '<p class="mpt-ev__extrait">' + echappe(e.extrait) + '</p>' : '')
      +   '<span class="mpt-ev__lien">Voir le programme</span>'
      + '</div>';
    a.querySelector('.mpt-ev__titre')._ev = e;
    return a;
  }

  /* ------------------------------------------------------------ vue agenda */

  var zoneAgenda = document.getElementById('mpt-cal-agenda');

  function rendAgenda(liste, listePassee) {
    zoneAgenda.textContent = '';
    if (!liste.length) {
      var vide = document.createElement('p');
      vide.className = 'mpt-cal__vide';
      vide.textContent = 'Aucun \u00E9v\u00E9nement \u00E0 venir dans cette cat\u00E9gorie pour le moment.';
      zoneAgenda.appendChild(vide);
    }
    var moisCourant = '', groupe = null;
    liste.forEach(function (e) {
      var m = e.d.a + '-' + e.d.m;
      if (m !== moisCourant) {
        moisCourant = m;
        groupe = document.createElement('section');
        groupe.className = 'mpt-cal__groupe';
        var h = document.createElement('h2');
        h.className = 'mpt-cal__mois';
        h.textContent = MOIS_LONG[e.d.m - 1] + ' ' + e.d.a;
        groupe.appendChild(h);
        zoneAgenda.appendChild(groupe);
      }
      groupe.appendChild(fiche(e));
    });
    if (listePassee.length) {
      var det = document.createElement('details');
      det.className = 'mpt-cal__passes';
      var som = document.createElement('summary');
      som.textContent = listePassee.length + ' \u00E9v\u00E9nement' + (listePassee.length > 1 ? 's' : '')
                      + ' pass\u00E9' + (listePassee.length > 1 ? 's' : '');
      det.appendChild(som);
      listePassee.forEach(function (e) { det.appendChild(fiche(e)); });
      zoneAgenda.appendChild(det);
    }
  }

  /* ---------------------------------------------------------------filtres */

  var typeActif = '', types = [];
  aVenir.forEach(function (e) { if (e.type && types.indexOf(e.type) === -1) types.push(e.type); });
  types.sort(function (a, b) { return sansAccent(a) < sansAccent(b) ? -1 : 1; });

  var zoneFiltres = document.getElementById('mpt-cal-filtres');

  function construitFiltres() {
    if (!zoneFiltres || types.length < 2) return;
    var boutons = [{ val: '', nom: 'Tout' }].concat(types.map(function (t) { return { val: t, nom: t }; }));
    boutons.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mpt-cal__filtre';
      btn.setAttribute('aria-pressed', b.val === typeActif ? 'true' : 'false');
      btn.dataset.type = b.val;
      if (b.val) {
        btn.style.setProperty('--c', couleur(b.val));
        btn.innerHTML = '<span class="mpt-cal__pastille"></span>' + echappe(b.nom);
      } else {
        btn.textContent = b.nom;
      }
      btn.addEventListener('click', function () {
        typeActif = b.val;
        zoneFiltres.querySelectorAll('.mpt-cal__filtre').forEach(function (x) {
          x.setAttribute('aria-pressed', x.dataset.type === typeActif ? 'true' : 'false');
        });
        applique();
      });
      zoneFiltres.appendChild(btn);
    });
  }

  function filtre(liste) {
    return typeActif ? liste.filter(function (e) { return e.type === typeActif; }) : liste;
  }

  /* -------------------------------------------------------------- vue mois */

  var grille = null;
  var zoneMois = document.getElementById('mpt-cal-mois');

  function pourFullCalendar(liste) {
    return liste.map(function (e) {
      var b = e.f || e.d;
      var finExclusive = new Date(Date.UTC(b.a, b.m - 1, b.j + 1, 12));
      return {
        title: e.titre,
        start: cle(e.d),
        end: finExclusive.toISOString().slice(0, 10),
        allDay: true,
        url: e.url,
        extendedProps: { c: e.c, h: e.d.h !== null ? heure(e.d) : '', type: e.type, i: e.i }
      };
    });
  }

  function construitMois() {
    if (grille || typeof FullCalendar === 'undefined') return;
    var hote = document.getElementById('calendar');
    if (!hote) return;
    var premier = aVenir[0] || evenements[0];
    grille = new FullCalendar.Calendar(hote, {
      initialView: 'dayGridMonth',
      locale: 'fr',
      firstDay: 1,
      height: 'auto',
      initialDate: premier ? cle(premier.d) : undefined,
      headerToolbar: { left: 'prev,next', center: 'title', right: 'today' },
      buttonText: { today: 'Aujourd\u2019hui' },
      dayMaxEvents: 3,
      moreLinkText: function (n) { return '+ ' + n + ' autre' + (n > 1 ? 's' : ''); },
      displayEventTime: false,
      events: pourFullCalendar(filtre(evenements)),
      eventContent: function (arg) {
        var el = document.createElement('div');
        el.className = 'mpt-pill';
        el.style.setProperty('--c', arg.event.extendedProps.c);
        el.dataset.ev = arg.event.extendedProps.i;
        var h = arg.event.extendedProps.h;
        el.innerHTML = (h ? '<span class="mpt-pill__h">' + h + '</span>' : '')
                     + '<span class="mpt-pill__t">' + echappe(arg.event.title) + '</span>';
        return { domNodes: [el] };
      },
      eventClick: function (info) {
        if (info.event.url) { info.jsEvent.preventDefault(); window.location.href = info.event.url; }
      }
    });
    grille.render();
  }

  function majMois() {
    if (!grille) return;
    grille.removeAllEventSources();
    grille.addEventSource(pourFullCalendar(filtre(evenements)));
  }

  /* ---------------------------------------------------------- carte survol */

  var carte = null, attente = null, survole = null;

  function creeCarte() {
    if (carte) return carte;
    carte = document.createElement('div');
    carte.className = 'mpt-carte';
    carte.setAttribute('aria-hidden', 'true');
    document.body.appendChild(carte);
    return carte;
  }

  function remplitCarte(e) {
    var c = creeCarte();
    c.style.setProperty('--c', e.c);
    c.innerHTML =
        (e.image ? '<div class="mpt-carte__affiche"><img src="' + e.image + '" alt="" width="240" height="320"></div>'
                 : '<div class="mpt-carte__affiche"></div>')
      + '<div>'
      +   (e.type ? '<span class="mpt-carte__type">' + echappe(e.type) + '</span>' : '')
      +   '<p class="mpt-carte__titre">' + echappe(e.titre)
      +     (e.sous ? ' <span style="font-weight:400">\u2014 ' + echappe(e.sous) + '</span>' : '') + '</p>'
      +   '<p class="mpt-carte__quand">' + echappe(texteQuand(e))
      +     (e.serie ? '<br>' + echappe(texteSerie(e)) : '') + '</p>'
      +   (e.extrait ? '<p class="mpt-carte__texte">' + echappe(e.extrait) + '</p>' : '')
      +   '<p class="mpt-carte__pied">Voir le programme \u2192</p>'
      + '</div>';
    return c;
  }

  function placeCarte(cible) {
    var r = cible.getBoundingClientRect();
    var vueL = document.documentElement.clientWidth;
    var l = carte.offsetWidth, h = carte.offsetHeight;
    var x = Math.max(12, Math.min(r.left, vueL - l - 12));
    var y = r.bottom + 10;
    if (y + h > window.innerHeight - 8) y = Math.max(8, r.top - h - 10);
    carte.style.left = x + window.scrollX + 'px';
    carte.style.top  = y + window.scrollY + 'px';
  }

  function ouvreCarte(cible) {
    var e = cible._ev || evenements[+cible.dataset.ev];
    if (!e) return;
    survole = cible;
    remplitCarte(e);
    carte.dataset.ouverte = 'false';
    placeCarte(cible);
    carte.dataset.ouverte = 'true';
  }

  function fermeCarte() {
    clearTimeout(attente);
    survole = null;
    if (carte) carte.dataset.ouverte = 'false';
  }

  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (ev) {
      var cible = ev.target.closest ? ev.target.closest('[data-ev]') : null;
      if (!cible || cible === survole) return;
      clearTimeout(attente);
      attente = setTimeout(function () { ouvreCarte(cible); }, 140);
    });
    document.addEventListener('mouseout', function (ev) {
      var cible = ev.target.closest ? ev.target.closest('[data-ev]') : null;
      if (cible && cible === survole) fermeCarte();
      else if (cible) clearTimeout(attente);
    });
    window.addEventListener('scroll', fermeCarte, { passive: true });
    window.addEventListener('resize', fermeCarte);
  }

  /* ---------------------------------------------------------- bascule vues */

  var vues = socle.querySelectorAll('.mpt-cal__vue');

  function montre(nom) {
    fermeCarte();
    vues.forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.vue === nom ? 'true' : 'false');
    });
    zoneAgenda.hidden = nom !== 'agenda';
    if (zoneMois) zoneMois.hidden = nom !== 'mois';
    if (nom === 'mois') { construitMois(); if (grille) grille.updateSize(); }
  }

  vues.forEach(function (b) {
    b.addEventListener('click', function () { montre(b.dataset.vue); });
  });

  // Pas de FullCalendar charge : on retire proprement la vue "Mois".
  if (typeof FullCalendar === 'undefined') {
    vues.forEach(function (b) { if (b.dataset.vue === 'mois') b.remove(); });
    if (zoneMois) zoneMois.remove();
  }

  function applique() {
    fermeCarte();
    rendAgenda(regroupeSeries(filtre(aVenir), true), regroupeSeries(filtre(passes), false).reverse());
    majMois();
  }

  construitFiltres();
  applique();
  montre('agenda');
})();

